import axios from 'axios';

const WEATHER_ALERTS_API_BASE = '/api/services/weather-alerts';

export const weatherAlertsService = {
  /**
   * Get triggered alerts for the notification bell
   */
  async getTriggeredAlerts() {
    try {
      const response = await axios.get(`${WEATHER_ALERTS_API_BASE}/triggered-alerts`);
      return { success: true, data: response.data };
    } catch (err) {
      const msg = err?.response?.data?.error_description || err?.response?.data?.Message || err.message;
      return { success: false, error: msg };
    }
  },

  /**
   * Dismiss a triggered alert notification
   */
  async dismissTriggeredAlert(weatherAlertHistoryId) {
    try {
      const response = await axios.put(`${WEATHER_ALERTS_API_BASE}/${weatherAlertHistoryId}/dismiss-notification`);
      return { success: true, data: response.data };
    } catch (err) {
      const msg = err?.response?.data?.error_description || err?.response?.data?.Message || err.message;
      return { success: false, error: msg };
    }
  },

  /**
   * Get weather alert by ID
   */
  async getWeatherAlertById(id) {
    try {
      const response = await axios.get(`${WEATHER_ALERTS_API_BASE}/${id}`);
      return { success: true, data: response.data };
    } catch (err) {
      const msg = err?.response?.data?.error_description || err?.response?.data?.Message || err.message;
      return { success: false, error: msg };
    }
  },

  async createWeatherAlertConfig(payload) {
    try {
      const response = await axios.post(`${WEATHER_ALERTS_API_BASE}/create-alert`, payload);
      return { success: true, data: response.data };
    } catch (err) {
      const msg = err?.response?.data?.error_description || err?.response?.data?.Message || err.message;
      return { success: false, error: msg };
    }
  },

  async updateWeatherAlertConfig(payload) {
    try {
      const response = await axios.put(`${WEATHER_ALERTS_API_BASE}/update-alert`, payload);
      return { success: true, data: response.data };
    } catch (err) {
      const msg = err?.response?.data?.error_description || err?.response?.data?.Message || err.message;
      return { success: false, error: msg };
    }
  },

  async deleteWeatherAlert(id) {
    try {
      await axios.delete(`${WEATHER_ALERTS_API_BASE}/${id}/weather-alert-configs`);
      return { success: true, data: null };
    } catch (err) {
      const msg = err?.response?.data?.error_description || err?.response?.data?.Message || err.message;
      return { success: false, error: msg };
    }
  },

  /**
   * Search weather alert configurations
   */
  async searchWeatherAlertsConfigs(requestPayload) {
    try {
      const response = await axios.post(`${WEATHER_ALERTS_API_BASE}/search-configs`, requestPayload);
      return { success: true, data: response.data };
    } catch (err) {
      const msg = err?.response?.data?.error_description || err.message;
      return { success: false, error: msg, data: [] };
    }
  },

  /**
   * Get global flag for weather alerts
   */
  async getWeatherAlertsGlobalFlag() {
    try {
      const response = await axios.get(`${WEATHER_ALERTS_API_BASE}/get-global-flag`);
      const core = response.data || { alertsEnabled: false };
      const enabled = !!(core.alertsEnabled ?? core.AlertsEnabled);
      const weatherAlertUserSettingsId = core.weatherAlertUserSettingsId ?? core.WeatherAlertUserSettingsId ?? null;
      return { success: true, data: { alertsEnabled: enabled, weatherAlertUserSettingsId } };
    } catch (err) {
      return { success: false, error: err?.response?.data };
    }
  },

  /**
   * Update global flag for weather alerts
   */
  async updateWeatherAlertsGlobalFlag(alertsEnabled) {
    try {
      const response = await axios.put(`${WEATHER_ALERTS_API_BASE}/update-global-flag`, { alertsEnabled });
      const core = response.data || { alertsEnabled: !!alertsEnabled };
      const enabled = !!(core.alertsEnabled ?? core.AlertsEnabled);
      return { success: true, data: { alertsEnabled: enabled } };
    } catch (err) {
      const resp = err?.response?.data;
      const msg = resp?.ModelState || resp?.error_description || resp?.Message || err.message;
      return { success: false, error: msg };
    }
  },

  async getCustomLocations(weatherAlertUserSettingsId) {
    try {
      const response = await axios.get(`${WEATHER_ALERTS_API_BASE}/${weatherAlertUserSettingsId}/custom-locations`);
      return { success: true, data: response.data };
    } catch (err) {
      const msg = err?.response?.data?.error_description || err?.response?.data?.Message || err.message;
      console.error('weatherAlertsService.getCustomLocations failed:', msg);
      return { success: false, data: null, error: msg };
    }
  },

  async uploadCustomLocations(weatherAlertUserSettingsId, file) {
    try {
      const formData = new FormData();
      formData.append('file', file);
      const response = await axios.post(
        `${WEATHER_ALERTS_API_BASE}/${weatherAlertUserSettingsId}/upload-custom-locations`,
        formData,
        { handleError: false }
      );
      return { success: true, data: response.data, error: null };
    } catch (err) {
      const msg = err?.response?.data?.error_description || err?.response?.data?.Message || err.message;
      console.error('weatherAlertsService.uploadCustomLocations failed:', msg);
      return { success: false, data: null, error: msg };
    }
  },

  async deleteCustomLocations(weatherAlertUserSettingsId) {
    try {
      const response = await axios.delete(`${WEATHER_ALERTS_API_BASE}/${weatherAlertUserSettingsId}/custom-locations`, {
        handleError: false
      });
      return { success: true, data: response.data, error: null };
    } catch (err) {
      const msg = err?.response?.data?.error_description || err?.response?.data?.Message || err.message;
      console.error('weatherAlertsService.deleteCustomLocations failed:', msg);
      return { success: false, data: null, error: msg };
    }
  }
};

export default weatherAlertsService;
